import { useState } from 'react'
import { SpinnerGrey } from '../../../../components/stories/atoms/icons/special/index.js'
import { iconSizeOptions } from '../../../../components/stories/atoms/icons/icons-sizes.js'
import { SsoItemImage, SsoSpinerContainer } from './styled-components.js'

export const ImageLoader = ({
  src,
  alt,
  size = iconSizeOptions['ICON-L'],
  ...props
}) => {
  const [isLoading, setIsLoading] = useState(true)

  const handleLoadedImage = () => {
    setIsLoading(false)
  }

  return (
    <>
      {isLoading && (
        <SsoSpinerContainer>
          <SpinnerGrey size={size} />
        </SsoSpinerContainer>
      )}
      <SsoItemImage
        src={src}
        alt={alt}
        onLoad={handleLoadedImage}
        style={{ display: isLoading ? 'none' : 'block' }}
        {...props}
      />
    </>
  )
}
